
import { jobs } from "@/api/jobs"
import { OtherDocumentRepository } from "../domain/OtherDocumentRepository"
import { WorkflowTemplateRepository } from "../domain/WorkflowRepositories"
import { VueOtherDocumentListScreenData } from "../infra/VueOtherDocumentListScreenData"

export class OtherDocListComponent {
    
    document_repo:OtherDocumentRepository
    screen_data: VueOtherDocumentListScreenData
    wf_repo: WorkflowTemplateRepository

    constructor(document_repo:OtherDocumentRepository, screen_data: VueOtherDocumentListScreenData, wf_repo: WorkflowTemplateRepository) {
        this.document_repo = document_repo
        this.screen_data = screen_data
        this.wf_repo = wf_repo
    }

    async fetchDocTypes() {
        return await this.document_repo.getAvailableTypes()
    }

    async mountMobile(company_id, types) {
        this.screen_data.user_permissions = await this.getUserPermissions(company_id);
        let fetchTypes = await this.fetchDocTypes()
        fetchTypes.filter(type => type.toLowerCase() !== 'otros').forEach(type => {
            const type_build = {id: types.length+1, name: type, value: type, selected: false}
            types.push(type_build)
        });
        await this.searchDocuments(company_id)
        this.getCompanyFolders(company_id)
        let res = await this.wf_repo.get_workflow_templates()
        this.screen_data.workflowOptions.push(...Object.values(res));
    }

    async mount(company_id) {
        this.screen_data.user_permissions = await this.getUserPermissions(company_id);
        console.log(this.screen_data.user_permissions)
        let types = await this.fetchDocTypes()
        types.filter(type => type.toLowerCase() !== 'otros').forEach(type => {
            this.screen_data.availableFilters['type']['user_values'].push(
                { 
                    value: type,
                    text: type
                }
            );
        });
        await this.searchDocuments(company_id)
        this.getCompanyFolders(company_id)
        let res = await this.wf_repo.get_workflow_templates()
        this.screen_data.workflowOptions.push(...Object.values(res));
    }

    async getUserPermissions(company_id):Promise<Object>{
        let args = {company_id}
        return await this.document_repo.getUserPermissions(args)
    }

    updateFilters(params) {
        Object.values(this.screen_data.availableFilters).forEach(element => {
            if (params.key === element.name) {
                element.value = params.value;
                element.text = params.text;
            }
        });
    }

    celanAllFilters() {
        Object.values(this.screen_data.availableFilters).forEach(element => {
            element.value = '';
            element.text = '';
        });
        this.screen_data.offset = 0
        this.screen_data.currentPage = 1
    }

    async searchDocuments(company_id, args={}) {
        args['company_id'] = company_id
        Object.values(this.screen_data.availableFilters).forEach(element => {
            args[element.name] = element.value;
        });
        args['limit'] = this.screen_data.limit
        args['offset'] = this.screen_data.offset
        args['folder_uuid'] = ""
        if (this.screen_data.currentFolderUUID != null && this.screen_data.currentFolderUUID != undefined){
            args['folder_uuid'] = this.screen_data.currentFolderUUID
        }
        try {
            this.screen_data.loading_odocs = true
            let data = await this.document_repo.get_documents(args)
            this.updateData(data['data'], data['count'])
        } catch (error) {
            this.screen_data.other_documents = []
            this.screen_data.totalItems = 0
            throw error
        }
        this.screen_data.loading_odocs = false
    }

    async sortTable(company_id, value) {
        let args = {}
        if (value && value[0] === true) {
            args['order_by'] = '-' + this.screen_data.sortBy
        } else if (value && value.length === 0) {
            args['order_by'] = ''
        } else {
            args['order_by'] = value[0]
        }
        await this.searchDocuments(company_id, args)
    }


    updateData(data, count) {
        this.screen_data.other_documents = data
        this.screen_data.selectedItems = []
        this.screen_data.totalItems = count
        if(this.screen_data.totalItems > 0){
            this.screen_data.showSelect = true
        }
        this.screen_data.selectAllItems = false;
        this.calculateTableHeight();
        this.screen_data.drawer = false;
    }

    calculateTableHeight() {
        this.screen_data.initNumItemsPerPage = Math.min(this.screen_data.limit, 10);
        if (this.screen_data.totalItems == 0) {
            this.screen_data.tableHeight = '20vh';
        }
        else {
            const rowHeight = document.querySelector('.text-start') && (document.querySelector('.text-start') as HTMLElement).offsetHeight || 48;
            this.screen_data.tableHeight = (rowHeight * (Math.min(this.screen_data.totalItems, this.screen_data.initNumItemsPerPage) + 1)).toString() + 'px';
        }
    }

    async deleteDocs(company_id) {
        let items_to_delete = this.screen_data.selectedItems.map(({id})=> id)
        let res = await this.confirm()
        if (res) {
            this.screen_data.loading_d_other_doc = true
            let args = { document_ids: items_to_delete, cascade_entities: this.screen_data.cascadeEntities }
            await this.document_repo.deleteDocuments(args)
            this.screen_data.loading_d_other_doc = false
            this.screen_data.selectedItems = []
            this.screen_data.cascadeEntities = false
            await this.searchDocuments(company_id)
        }
    }

    async confirmMoveDocumentsToFolder(selected_folder_uuid){
        this.confirmFolderPopUp(selected_folder_uuid)
    }

    async moveDocumentsToFolder(company_id) {
        let docs_to_move = this.screen_data.selectedItems.map(({id})=> id)
        let selected_folder = await this.userSelectsFolder();
        if (selected_folder == null) {
            return;
        }
        selected_folder = selected_folder=="Mi unidad"? null:selected_folder //se pone null ya que los ficheros con folder_uuid en null sera la carpeta root(Mi unidad)
        let args = { folder_uuid: selected_folder, doc_ids: docs_to_move, company_id: company_id }
        await this.document_repo.moveDocsToFolder(args)
    }

    async goToFolder(company_id){
        let selected_folder = await this.userSelectsFolder();
        if (selected_folder == null) { // '' for root
            return;
        }
        this.screen_data.currentFolderUUID = selected_folder +""
        this.screen_data.currentFolderRoute = this.getFolderRoute(this.screen_data.companyFolders, '',selected_folder)
        this.searchDocuments(company_id)
    }

    async moveToFolder(selected_folder){
        this.screen_data.currentFolderUUID = selected_folder
        this.screen_data.currentFolderRoute = this.getFolderRoute(this.screen_data.companyFolders, '',selected_folder)
    }

    getDataFolder(folders, folder_uuid){
        for(let i = 0;i<folders.length;i++){
            if (folders[i].id == folder_uuid){
                return folders[i]
            }
            if(folders[i].children && folders[i].children.length){
                const result = this.getDataFolder(folders[i].children, folder_uuid)
                if(result){
                    return result
                }
            }
        }
        return null
    }

    getFolderRoute(folders, so_far_route ,folder_uuid){
        for (let i = 0; i < folders.length; i++) {
            let folder = folders[i];
            if (folder.id == folder_uuid) {
                return so_far_route + folder.name;
            }
            if (folder.children) {
                let current_route = folder.name =='Mi unidad'? folder.name + '/' :so_far_route + folder.name + '/'
                let found_route = this.getFolderRoute(folder.children, current_route, folder_uuid);
                if (found_route) {
                    return found_route;
                }
            }
        }
    }

    confirm(){
        this.screen_data.showDeletePupup = true;
        return new Promise((resolve,reject)=>{
            this.screen_data.resolvePopupPromise = resolve
        })
    }

    async downloadDocs() {
        let doc_ids = this.screen_data.selectedItems.map(({id})=> id)
        if (this.screen_data.selectedItems.length == 1) {
            this.screen_data.documentName = this.screen_data.selectedItems[0].original_file_name
        } else {
            this.screen_data.documentName = 'listado_documentos.zip'
        }
        this.screen_data.action = 'download'
        let args = { doc_ids: doc_ids }
        let res = await this.document_repo.downloadDocuments(args)
        this.screen_data.asyncJobState = 'running';
        this.screen_data.asyncJobId = res.job_id
    }

    async downloadDocsMobile(doc) {
        console.log("doc_id", doc.id)
        this.screen_data.documentName = doc.original_file_name
        let args = { doc_ids: [doc.id] }
        let res = await this.document_repo.downloadDocuments(args)
        this.screen_data.action = 'download'
        this.screen_data.asyncJobState = 'running';
        this.screen_data.asyncJobId = res.job_id
    }

    async changeWorkflow() {
        let args = {
            doc_ids: this.screen_data.selectedItems.map(({id})=> id),
            wf_id: this.screen_data.selectedWorkflow
        }
        console.log('args', args)
        let res = await this.document_repo.changeDocsWorkflow(args)
        this.screen_data.asyncJobState = 'running';
        this.screen_data.asyncJobId = res.job_id;
        this.screen_data.dialogChangeWorkflow = false;
        this.screen_data.selectedWorkflow = undefined;
    }

    async relaunchWorkflow() { 
        let wfs_ids = this.screen_data.selectedItems.map(({workflow_id})=> workflow_id)
        //check all wfs_ids are the same
        if (wfs_ids.some((wf_id) => wf_id !== wfs_ids[0])) {
            this.screen_data.errorPopUp = true
            this.screen_data.errorPopUpDescription = 'ViesValidator.not_same_wf'
        }
        else{
            this.screen_data.selectedWorkflow = wfs_ids[0]
            this.changeWorkflow()
        }
    }
    async jobDone(company_id){
        const response = await jobs.getJob({ id: this.screen_data.asyncJobId });
        this.screen_data.asyncJobState = response.data.state;
        let recived_url = response.data.output_info;
        if (this.screen_data.action == 'download') {
            const res = await fetch(recived_url)
            const blob = await res.blob();
            const url = await URL.createObjectURL(blob)
            const a = document.createElement("a");
            a.href = url;
            a.download = this.screen_data.documentName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } else  {
            this.searchDocuments(company_id)
        }
    }

    async getCompanyFolders(company_id) {
        let args = { company_id }
        let folder_map =  await this.document_repo.getCompanyFolders(args)
        this.screen_data.companyFolders = [{'name':'Mi unidad','id':'Mi unidad', 'children': folder_map}]
    }

    userSelectsFolder() {
        this.screen_data.popUpSelectFolder = true;
        return new Promise((resolve) => {
            this.screen_data.resolveSelectedFolderPromise = resolve;
        });
    }
    confirmFolderPopUp(folder_uuid) {
        this.screen_data.popUpSelectFolder = false;
        if (this.screen_data.resolveSelectedFolderPromise) {
            this.screen_data.resolveSelectedFolderPromise(folder_uuid);
            this.screen_data.resolveSelectedFolderPromise = null;
        }
    }
    cancelFolderPopUp() {
        this.screen_data.popUpSelectFolder = false;
        if (this.screen_data.resolveSelectedFolderPromise) {
            this.screen_data.resolveSelectedFolderPromise(null);
            this.screen_data.resolveSelectedFolderPromise = null;
        }
    }
    async chooseFolder() {
        let selected_folder = await this.userSelectsFolder();
        console.log('Selected folder:', selected_folder);
    }
    async createFolder(companydb_id, selected_folder_parent) {
        selected_folder_parent = selected_folder_parent === 'Mi unidad' ? undefined : selected_folder_parent
        let args = {}
        args['name'] = this.screen_data.newFolderName
        args['company_id'] = companydb_id
        args['parent_uuid'] = selected_folder_parent
        args['is_private'] = this.screen_data.is_private


        let result = await this.document_repo.saveFolder(args)
        await this.getCompanyFolders(companydb_id)

        this.screen_data.newFolderName = ''
        this.screen_data.is_private = false
        this.screen_data.popUpCreateFolder = false;
        return result
    }
    showPopUpCreateFolder(folder) {
        this.screen_data.selectedFolderParent = folder
        this.screen_data.popUpCreateFolder = true;
    }
    cancelCreateFolder() {
        this.screen_data.newFolderName = ''
        this.screen_data.is_private = false
        setTimeout(() => {
            this.screen_data.popUpCreateFolder = false;
        }, 100)
    }

    showPopUpEditFolder(folders, folder_uuid) {
        const folder = this.getDataFolder(folders, folder_uuid)
        this.screen_data.folder_data = JSON.parse(JSON.stringify(folder))
        this.screen_data.unedited_folder_data = JSON.parse(JSON.stringify(folder))
        this.screen_data.popUpEditFolder = true;
    }

    changeDetector() {
        if(this.screen_data.folder_data && this.screen_data.folder_data.name != "" && (this.screen_data.folder_data.name != this.screen_data.unedited_folder_data.name ||this.screen_data.folder_data.is_private != this.screen_data.unedited_folder_data.is_private)){
            return true
        }
        return false
    }

    cancelEditFolder(){
        setTimeout(() => {
            this.screen_data.popUpEditFolder = false;
        }, 100)
    }

    async editFolder(companydb_id, folder_uuid, name, is_private){
        let args = {}
        args['company_id'] = companydb_id
        args['uuid'] = folder_uuid
        args['name'] = name
        args['is_private'] = is_private

        const edit_folder_uuid = await this.document_repo.saveFolder(args)
        await this.getCompanyFolders(companydb_id)
        const parts = this.screen_data.currentFolderRoute.split("/")
        const withoutLast = parts.slice(0, -1).join("/")
        this.screen_data.currentFolderRoute = withoutLast+"/"+name
        this.screen_data.popUpEditFolder = false;
        return edit_folder_uuid
    }


    async deleteFolder(selected_folder: string, companydb_id:number, deleteContent: boolean): Promise<boolean> {
        const commandArgs = {
            uuid: selected_folder,
            company_id: companydb_id,
            delete_content: deleteContent,
        };
        await this.document_repo.deleteFolder(commandArgs);
        await this.getCompanyFolders(companydb_id);

        this.screen_data.popUpDeleteFolder = false;

        return deleteContent;
    }
    
    showPopUpDeleteFolder() {
        this.screen_data.popUpDeleteFolder = true;
    }
    cancelDeleteFolder() {
        setTimeout(() =>{
            this.screen_data.popUpDeleteFolder = false;
        }, 100)
    }

    async get_documents(args){
        try {
            let data = await this.document_repo.get_documents(args)
            this.updateData(data['data'], data['count'])
        } catch (error) {
            this.screen_data.other_documents = []
            throw error
        }
    }

    async get_documents_mobile(company_id, need_approval, original_file_name, type, date_from, date_to, order_by, limit=0, offset=0){
        let args = {
            company_id,
            need_approval,
            original_file_name,
            type,
            date_from,
            date_to,
            order_by,
            limit,
            offset
        }
        args['folder_uuid'] = ""
        if (this.screen_data.currentFolderUUID != null && this.screen_data.currentFolderUUID != undefined){
            args['folder_uuid'] = this.screen_data.currentFolderUUID
        }
        console.log("filtro", args)
        await this.get_documents(args)
    }
}